import { render } from "./Home2.vue?vue&type=template&id=38ae85e4"
import script from "./Home2.vue?vue&type=script&lang=js"
export * from "./Home2.vue?vue&type=script&lang=js"

import "./Home2.vue?vue&type=style&index=0&id=38ae85e4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__